import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-left">
          <div className="copyright">
            © {(() => {
              const startYear = 2025;
              const currentYear = new Date().getFullYear();
              return currentYear > startYear ? `${startYear} - ${currentYear}` : startYear;
            })()} BUMTOOLBOX. All rights reserved.
          </div>
        </div>
        <div className="footer-right">
          <nav className="footer-nav">
            <Link to="/about" className="footer-link">このサイトについて</Link>
            <Link to="/privacy" className="footer-link">プライバシーポリシー</Link>
            <Link to="/contact" className="footer-link">お問い合わせ</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
